import { styled, useTheme } from "@mui/system";
import { Typography, Avatar } from "@mui/material";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import RightArrowIcon from "assets/icons/RightArrowIcon";
import { MainCardContainer, TitleSection, TagComponent } from "./styled";
import { formatPrice, shortenString } from "helpers/dataFormat";

const RemindContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));
const LowerSection = styled("div")(({ theme }) => ({
  width: "100%",
  display: "grid",
  height: "100%",
  gridTemplateColumns: "24% 76%",
  justifyContent: "space-between",
}));
const ProfileSection = styled("div")(({ theme }) => ({
  display: "grid",
  height: "100%",
  justifyContent: "center",
  gridTemplateRows: "12% 35% 12%",
  gridTemplateColumns: "100%",

  paddingTop: "24px",
  gridGap: "5%",
  borderLeft: `solid 2px ${theme.palette.disabled.light}`,
}));
const ItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  // backgroundColor: 'red',
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  height: "96px",
  width: "96px",
  padding: "8px",
  border: `solid 2px ${theme.palette.disabled.contrastText}`,
}));
const DetailsSection = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "0 30px 0 30px",
  display: "grid",
  gridTemplateRows: "25%",
}));
const DetailsItem = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "24px 0 24px 0",
  borderBottom: `solid 2px ${theme.palette.disabled.light}`,
  display: "grid",
  gridTemplateColumns: "25% 25% 25% 25%",
}));
const AddressItem = styled(DetailsItem)(({ theme }) => ({
  gridTemplateColumns: "75% 25%",
}));
const DetailsSubItem = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));
const DetailsSubItemTitle = styled(Typography)(({ theme }) => ({
  marginBottom: "8px",
}));

const ProductMainCard = ({ data }: { data: any }) => {
  const theme = useTheme();
  return (
    <MainCardContainer>
      <TitleSection>
        <Typography variant="h6">
          {/*{data?.title ? shortenString(data?.title, 30) : ""}*/}
          {data?.accountingCode || ""} - {data?.title || ""}
        </Typography>
        <RemindContainer>
          <Typography variant="caption" color={theme.palette.disabled.main}>
            موجودی کل (انبارها + حسابداری):&nbsp;
          </Typography>
          <Typography variant="h6" style={{ direction: "ltr" }}>
            &nbsp;{data?.count ?? 0}&nbsp;
          </Typography>
          <Typography variant="caption" color={theme.palette.disabled.main}>
            {data?.unit || "عدد"}
          </Typography>
        </RemindContainer>
      </TitleSection>
      <LowerSection>
        <ProfileSection>
          <Typography textAlign="center" color={theme.palette.primary.main} variant="h6">
            {/*{data?.accountingCode || ""}*/}
          </Typography>
          <ItemContainer>
            <StyledAvatar src={data?.imageUrl || "/assets/images/productAvatar.svg"} />
          </ItemContainer>
          <ItemContainer>
            <TagComponent title={data?.formTypeTitle} />
            {/* <RightArrowIcon />
                        <TagComponent title="مشتری" /> */}
          </ItemContainer>
        </ProfileSection>
        <DetailsSection>
          <DetailsItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                کد کالا
              </DetailsSubItemTitle>
              <Typography variant="body1">{data?.code}</Typography>
            </DetailsSubItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                بارکد
              </DetailsSubItemTitle>
              <Typography variant="body1">{data?.barcode}</Typography>
            </DetailsSubItem>
          </DetailsItem>
          <DetailsItem>
            <DetailsSubItem>
              <Typography variant="body2" color={theme.palette.disabled.main}>
                واحد اصلی
              </Typography>
              <Typography variant="body1">{data?.unit}</Typography>
            </DetailsSubItem>
            {data?.subUnit && (
              <DetailsSubItem>
                <Typography variant="body2" color={theme.palette.disabled.main}>
                  واحد فرعی
                </Typography>
                <Typography variant="body1">{data?.subUnit}</Typography>
              </DetailsSubItem>
            )}
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                موجودی انبارها{" "}
              </DetailsSubItemTitle>
              <Typography variant="body1" style={{ direction: "ltr", textAlign: "end" }}>
                {data?.bill_product_count ?? 0}
              </Typography>
            </DetailsSubItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                موجودی حسابداری{" "}
              </DetailsSubItemTitle>
              <Typography variant="body1" style={{ direction: "ltr", textAlign: "end" }}>
                {parseInt(data?.factor_product_count ?? 0)}
              </Typography>
            </DetailsSubItem>
          </DetailsItem>
          <DetailsItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                قیمت خرید
              </DetailsSubItemTitle>
              <PriceComponent price={formatPrice(data?.buyPrice)} />
            </DetailsSubItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                قیمت فروش
              </DetailsSubItemTitle>
              <PriceComponent price={formatPrice(data?.sellPrice)} />
            </DetailsSubItem>
          </DetailsItem>
          <DetailsItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                مالیات خرید
              </DetailsSubItemTitle>
              <Typography variant="body1">{`${data?.buyTax || 0}%`}</Typography>
            </DetailsSubItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body2" color={theme.palette.disabled.main}>
                مالیات فروش
              </DetailsSubItemTitle>
              <Typography variant="body1">{`${data?.sellTax || 0}%`}</Typography>
            </DetailsSubItem>
          </DetailsItem>
        </DetailsSection>
      </LowerSection>
    </MainCardContainer>
  );
};

export default ProductMainCard;
